import { Button } from "@imi/ui/components/Button/Button.js";
import {
  Dialog,
  DialogActions,
  DialogBody,
  DialogClose,
  DialogCloseButton,
  DialogHeader,
} from "@imi/ui/components/Dialog/Dialog.js";
import { Heading } from "@imi/ui/components/Heading/Heading.js";
import { useTranslation } from "react-i18next";
import { Form } from "react-router";
import { useRouteDialogProps } from "../../hooks/useRouteDialogProps";
import { useProjectAddForm } from "./hooks/useProjectAddForm";
import styles from "./ProjectAddDialog.module.css";

export function ProjectAddDialog() {
  const { t } = useTranslation("project", { keyPrefix: "add" });
  const routeDialogProps = useRouteDialogProps();
  const { form, submitting } = useProjectAddForm();

  return (
    <Dialog {...routeDialogProps} className={styles.ProjectAddDialog}>
      <DialogHeader>
        <Heading as="h3" subTitle={t("subTitle")}>
          {t("title")}
        </Heading>
      </DialogHeader>
      <DialogBody className={styles.DialogBody}>
        <Form
          id={form.formId}
          onSubmit={(e) => {
            e.preventDefault();
            e.stopPropagation();
            form.handleSubmit(e);
          }}
        >
          <fieldset>
            <form.AppField name="name">
              {(field) => (
                <field.TextField
                  autoFocus
                  label={t("fields.name.label")}
                  placeholder={t("fields.name.placeholder")}
                />
              )}
            </form.AppField>
            <form.AppField name="description">
              {(field) => (
                <field.TextField
                  as="textarea"
                  label={t("fields.description.label")}
                  placeholder={t("fields.description.placeholder")}
                  rows={7}
                />
              )}
            </form.AppField>
          </fieldset>
        </Form>
      </DialogBody>
      <DialogActions className={styles.DialogActions}>
        <DialogClose disabled={submitting} variant="outline">
          {t("actions.cancel")}
        </DialogClose>
        <Button form={form.formId} loading={submitting} type="submit">
          {t("actions.confirm")}
        </Button>
      </DialogActions>
      <DialogCloseButton>{t("actions.close")}</DialogCloseButton>
    </Dialog>
  );
}
